export interface FinRecurrence {
    type: TypeEnum
    date?: Date;
    nombreOccurrence?: number;
}

export enum TypeEnum {
  Never = "never",
  Date = "date",
  OcurrenceNumber = "ocurrenceNumber",
}
